import axios from 'axios';
import { Store } from '../../../store/player/types';
import { readOnly } from './readOnly';

/**
 * Get Incoming Feedback data used by the IF creation prompt in the Recording end modal.
 */
export const fetchFeedbackData = (store: Store): Promise<void> => {
  const { siteId, sharingToken, setHasNoIncomingFeedback } = store.getState();

  if (readOnly(store)) {
    return Promise.resolve();
  }

  return axios
    .get(`/api/v1/sites/${siteId}/feedback/count`, { params: { token: sharingToken } })
    .then((response) => {
      if (response.data !== undefined && response.data.count === 0) {
        setHasNoIncomingFeedback();
      }
    });
};
